import Fe from '../ui/FormElement';

export default [
    Fe.Text("name", "Name"),
    Fe.Textarea("description", "Description"),
    Fe.Checkbox("is_special", "Special"),
    Fe.Number("servings", "Servings in Recipe"),
]
